<template>
  <div :class="readyForShow ? '':'prepare'">
    <div :class="containerClass">
      <div class="pagination">
        <span v-if="current <= 1">
          {{ t('common.prev_page') }}
        </span>
        <a v-else :href="getUrl(parseInt(current)-1)" >
          {{ t('common.prev_page') }}
        </a>
        <template v-for="item in showPageNum">
          <a :key="item" :href="getUrl(item)" :class="current == item ? 'active':''">
            {{ item }}
          </a>
        </template>
        <span v-if="current >= max">
          {{ t('common.next_page') }}
        </span>
        <a v-else :href="getUrl(parseInt(current)+1)" >
          {{ t('common.next_page') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    containerClass: {
      type: String,
      default: 'pager-container'
    },
    current: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1
    },
    prefix: {
      type: String,
      default: ""
    }
  },
  data: function () {
    return {
      pageNum: [],
      showPageNum: [],
      readyForShow: false
    }
  },

  mounted() {
    try {
      this.updatePageNum()
      this.getPageNum()
    } catch (e) {
      console.error('Pager Error', { msg: e })
    }
  },
  methods: {
    getUrl: function(page) {
      return this.prefix + '?page=' + page
    },
    updatePageNum: function () {
      const pageNumList = this.pageNum
      const index = this.current
      if (pageNumList.length > 0) {
        if (index !== -1) {
          if (index >= 1 && index <= 3) {
          // In First Five
            this.showPageNum = pageNumList.slice(0, 5)
          } else if (index >= pageNumList.length - 3) {
          // In List Five
            const last = pageNumList.length
            this.showPageNum = pageNumList.slice(last - 5, last)
          // Middle
          } else {
            this.showPageNum = pageNumList.slice(index - 2, index + 3)
          }
        } else {
          console.error('Page Number Wrong')
        }
      }
      // End
    },

    getPageNum: function () {
      const pageNumList = []
      for (let i = 1; i <= this.max; i++) {
        pageNumList.push(i)
      }
      this.pageNum = pageNumList
      this.updatePageNum()
      this.readyForShow = true
    }
  }
}
</script>

<style>

</style>
